/**
 * Stack routes of the native screens added by the `storecfg` admin-module group
 * (sections of the store settings: closing report / e-mail, quote PDF, commission, branding).
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'StoreCfgClosingReportScreen', component: lazyScreen(() => import('../../screens/adminModules/storecfg/StoreCfgClosingReportScreen'))},
    {name: 'StoreCfgClosingEmailScreen', component: lazyScreen(() => import('../../screens/adminModules/storecfg/StoreCfgClosingEmailScreen'))},
    {name: 'StoreCfgQuotePdfScreen', component: lazyScreen(() => import('../../screens/adminModules/storecfg/StoreCfgQuotePdfScreen'))},
    {name: 'StoreCfgCommissionScreen', component: lazyScreen(() => import('../../screens/adminModules/storecfg/StoreCfgCommissionScreen'))},
    {name: 'StoreCfgBrandingScreen', component: lazyScreen(() => import('../../screens/adminModules/storecfg/StoreCfgBrandingScreen'))},
];

export default ROUTES;
